/**
 * Ponto de entrada.
 *
 * O arranque tem de contar sempre a mesma historia: ou abre, ou explica em
 * portugues porque nao abriu. Nunca uma tela branca, nunca um "erro inesperado".
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@flos/ui';
import './styles/app.css';
import { boot } from './boot';
import { App } from './App';

const container = document.getElementById('raiz');

function fatal(message: string): void {
  if (!container) return;
  container.innerHTML = '';
  const box = document.createElement('div');
  box.className = 'flos-arranque flos-arranque--erro';
  box.setAttribute('role', 'alert');
  const title = document.createElement('p');
  title.className = 'flos-arranque__marca';
  title.textContent = 'Não consegui abrir';
  const text = document.createElement('p');
  text.className = 'flos-arranque__texto';
  text.textContent = message;
  const retry = document.createElement('button');
  retry.className = 'flos-arranque__botao';
  retry.textContent = 'Tentar outra vez';
  retry.onclick = () => window.location.reload();
  box.append(title, text, retry);
  container.append(box);
}

async function start(): Promise<void> {
  if (!container) throw new Error('Falta o elemento #raiz no index.html');

  const result = await boot();
  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <App boot={result} />
      </BrowserRouter>
    </StrictMode>,
  );
}

void start().catch((error: unknown) => {
  // Falhar a abrir a base de dados local e o unico caso mesmo fatal: sem ela
  // nao ha dados nenhuns para mostrar.
  console.error('[flos] arranque falhou', error);
  fatal(
    'Houve um problema a abrir os seus dados neste aparelho. Feche o aplicativo e volte a abrir. Se continuar, peça ajuda a quem administra a família.',
  );
});
